import { render } from "./detail-tenaga-ahli-pra_pelaksanaan.vue?vue&type=template&id=0c44df22"
import script from "./detail-tenaga-ahli-pra_pelaksanaan.vue?vue&type=script&lang=js"
export * from "./detail-tenaga-ahli-pra_pelaksanaan.vue?vue&type=script&lang=js"

import "./detail-tenaga-ahli-pra_pelaksanaan.vue?vue&type=style&index=0&id=0c44df22&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__